export function KPIStatCard({ label, value, hint, accent = 'info', testId }) {
    const accentClass = {
        info: 'text-[hsl(var(--info))]',
        success: 'text-[hsl(var(--success))]',
        warning: 'text-[hsl(var(--warning))]',
        danger: 'text-[hsl(var(--danger))]',
        neutral: 'text-foreground',
    }[accent || 'info'];
    return (
        <div
            className="rounded-xl border border-border bg-card p-4 shadow-sm transition-colors duration-150 hover:border-[hsl(var(--brand-accent-current)/0.45)]"
            data-testid={testId || 'dashboard-kpi-card'}
        >
            <div className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
                {label}
            </div>
            <div className={`mt-2 text-3xl font-semibold tabular-nums ${accentClass}`}>
                {value}
            </div>
            {hint ? (
                <div className="mt-1 text-xs text-muted-foreground">{hint}</div>
            ) : null}
        </div>
    );
}
